// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterDomain_root__DgTun"};